import moment from 'moment'
import PropTypes from 'prop-types'

import { useEffect } from 'react'
import { saveAs } from 'file-saver'
import { memo, useState } from 'react'
import { Tooltip } from '@material-ui/core'

import { Colors } from '~/styles'
import { Images } from '~/assets'
import { Button, Loading } from '~/components'
import { ServiceRequestAPI } from '~/api'

import Styled from './list-document.styled'

const ListDocument = (props) => {
  let zip = require('jszip')()

  const [user, setUser] = useState('')
  const [isDownloading, setIsDownloading] = useState(false)

  const _getUser = async () => {
    let rawUser = await localStorage.getItem('user_info')
    let user = await JSON.parse(rawUser)
    user && setUser(`${user.User.Name} (${user.User.Company})`)
  }
  useEffect(() => {
    _getUser()
  }, [])

  const data = props.data.length > 0 && props.data.map(p =>
    p.created_date === undefined ? { ...p, created_date: new Date().toISOString() } : p
  )

  const _getBase64 = async (files) => {
    try {
      const formData = new FormData()
      formData.append('action', 'DOWNLOAD')
      formData.append('file', files.filename)
      const response = await ServiceRequestAPI.DownloadAttachment(formData)
      if (response && response.data.message.data) {
        return response.data.message.data
      }
    } catch (error) {
      return error
    }
  }

  const _downloadAll = () => {
    setIsDownloading(true)
    try {
      let fileArr = []
      const files = props.data
      files.map((file) => {
        const response = _getBase64(file)
        if (response) {
          fileArr.push({ filename: file.filename, blob: response })
        }
      })

      if (fileArr.length !== 0) {
        fileArr.map(data => {
          zip.file(data.filename, data.blob, { base64: true }
          )
        })
        zip.generateAsync({ type: 'blob' }).then(content => {
          saveAs(content, props.srNo + ' (' +
            moment(new Date()).format('DD-MM-YYYY HH:mm:ss') + ').zip')
        })
        zip = require('jszip')()
      }
    } catch (error) {
      console.log('Error downloading files:', error)
    } finally {
      setIsDownloading(false)
    }
  }

  return (
    <Styled.Wrapper
      scrollable={props.type === 'scrollable' ? true : false}
      type={props.type === 'general' ? 'background' : 'no-background'}
    >
      <Styled.WrapperList>
        <Button
          id='list_files_button_upload'
          type='button'
          height={40}
          disable={props.isUpload}
          onClick={props.onClickUpload}
          style={{
            color: props.isUpload ? Colors.grey : Colors.black,
            marginBottom: '12px',
            backgroundColor: props.isUpload ? Colors.borderGrey : Colors.white,
          }}
        >
          {!props.isUpload && (
            <>
              <Styled.Image src={Images.upload} />
              Upload Files
            </>
          )}
          {props.isUpload && (
            <>
              Uploading Files...
              <Styled.LoadingWrapper>
                <Loading size={16} />
              </Styled.LoadingWrapper>
            </>
          )}
        </Button>
        {props.isDownloadAll &&
          <Styled.Description
            id='list_files_button_download_all'
            cursor='pointer'
            onClick={_downloadAll}
          >
            {!isDownloading && 'Download All'}
            {isDownloading && (
              <>
                Downloading All Document...
                <Styled.LoadingWrapper>
                  <Loading size={16} />
                </Styled.LoadingWrapper>
              </>
            )}
          </Styled.Description>
        }

      </Styled.WrapperList>

      {data.length > 0 && data.sort((a, b) => a.created_date.localeCompare(b.created_date)).map((item, index) => {
        let counting = item.filename.split('.')[0].split('_').length
        let origin = item.filename.split('.')[0].split('_')[counting - 1]
        let nameFile = item.filename.split('_' + origin.toString())[0] + '.' + item.filename.split('.')[1]

        // File uploaded from SR has a unique code
        // while file uploaded from cargo hasn't
        // so pass type 'general' to this component if uploaded file has a unique code
        const filename = props.type === 'general' ? nameFile : item.filename

        return (
          <Styled.WrapperList
            key={index}
            type='list-item'
            id={`list_files_itemlist${index}`}
            className={index === 0 ? 'mt-0' : ''}
          >
            <Styled.ListItem fullWidth={props.fullWidth}>
              <Styled.Image size='xl'
                src={
                  item.filename.split('.')[1].toLowerCase() == 'pdf'
                    ? Images.filesIconPdf
                    : item.filename.split('.')[1].toLowerCase() == 'xls' || item.filename.split('.')[1].toLowerCase() == 'xlsx'
                      ? Images.filesIconXls
                      : item.filename.split('.')[1].toLowerCase() == 'doc' || item.filename.split('.')[1].toLowerCase() == 'docx'
                        ? Images.filesIconDoc
                        : item.filename.split('.')[1].toLowerCase() == 'jpg' || item.filename.split('.')[1].toLowerCase() == 'jpeg' || item.filename.split('.')[1].toLowerCase() == 'png'
                          ? Images.filesIconImg : Images.filesIconPst
                } />
              <Styled.WrapperRowSpace>
                <Styled.WrapperColumn>
                  <Styled.WrapperRow type={props.type}>
                    <a href={item.path}
                      target='_blank' rel='noreferrer'
                      id={`list_files_button${index}`}
                    >
                      <Styled.FileTitle>{filename > 100 ? filename.substring(0, 100) + '.....' : filename}</Styled.FileTitle>
                    </a>
                  </Styled.WrapperRow>
                  <Styled.WrapperRow>
                    <Styled.IconGroup>
                      <Styled.Description>
                        {(item.filesize / 1000).toFixed(1)} KB
                      </Styled.Description>
                    </Styled.IconGroup>
                    <Styled.IconGroup>
                      <Styled.Image src={Images.UploaderIcon} />
                      <Tooltip title={item.created_by_company ? item.created_by_company : user} arrow>
                        <Styled.Description>
                          {item.created_by_company
                            ? item.created_by_company.length > 40
                              ? item.created_by_company.substring(0, 40) + '...'
                              : item.created_by_company
                            : user.length > 40
                              ? user.substring(0, 40) + '...'
                              : user
                          }
                        </Styled.Description>
                      </Tooltip>
                    </Styled.IconGroup>
                    <Styled.IconGroup>
                      <Styled.Image src={Images.time} />
                      <Styled.WrapperRow>
                        {props.hasTime ?
                          <Styled.Description type='time'>{moment(item.created_date).format('DD/MM/YYYY HH:mm')}</Styled.Description>
                          :
                          <Styled.Description type='time'>{moment(item.created_date).format('DD/MM/YYYY')}</Styled.Description>
                        }
                      </Styled.WrapperRow>
                    </Styled.IconGroup>
                  </Styled.WrapperRow>
                </Styled.WrapperColumn>
                {props.isDownloadFile && (
                  <a href={item.path}
                    download={item.filename}
                    target='_blank' rel='noopener noreferrer'
                    id={`list_files_button_download${index}`}
                  >
                    <Styled.Image size='md' src={Images.download} />
                  </a>
                )}
              </Styled.WrapperRowSpace>

            </Styled.ListItem>
            {props.isDelete ? (
              <Styled.ContainerDel id={`list_files_button_deleted${index}`}>
                <Styled.DeleteIcon type='delete' src={Images.delete} onClick={() => props.onClickDelete(item)} />
              </Styled.ContainerDel>
            ) : props.type == 'Planning Attachment' ? (
              item.attachment_type_text == 'Planning Attachment' ?
                <Styled.ContainerDel id={`list_files_button_deleted${index}`}>
                  <Styled.DeleteIcon type='delete' src={Images.delete} onClick={() => props.onClickDelete(item)} />
                </Styled.ContainerDel>
                :
                <Styled.ContainerDel id={`list_files_button_deleted${index}`}>
                  <Styled.DeleteIcon src={Images.delete} />
                </Styled.ContainerDel>
            ) : (
              <Styled.ContainerDel id={`list_files_button_deleted${index}`}>
                <Styled.DeleteIcon src={Images.delete} />
              </Styled.ContainerDel>
            )}

          </Styled.WrapperList>
        )
      })}
    </Styled.Wrapper>
  )
}

ListDocument.propTypes = {
  data: PropTypes.array,
  srNo: PropTypes.string,
  isUpload: PropTypes.bool,
  isDelete: PropTypes.bool,
  fullWidth: PropTypes.bool,
  hasTime: PropTypes.bool,
  type: PropTypes.string,
  isDownloadFile: PropTypes.bool,
  onClickUpload: PropTypes.func,
  onClickDelete: PropTypes.func,
  isDownloadAll: PropTypes.bool,
}

ListDocument.defaultProps = {
  data: [],
  isUpload: true,
  isDelete: true,
  fullWidth: false,
  hasTime: false,
  type: 'general',
  isDownloadFile: true,
  isDownloadAll: false,
  onClickUpload: () => { },
  onClickDelete: () => { },
}

export default memo(ListDocument)